export default __webpack_public_path__ + "static/media/soja-gray.a8da89d1.svg";